import { type SnackbarFixedProps, useIntl } from '@capsicum/common';

export const useNCWRecipientEdit = () => {
	const { $t } = useIntl();

	const editSuccessSnackbarProp = {
		description: $t('wallet.withdraw.recipient.editRecipient.notificationSuccess'),
		testID: 'ncw-recipientEdit-editSuccess-snackbar',
		variant: 'success'
	} satisfies SnackbarFixedProps;

	const deleteSuccessSnackbarProp = {
		description: $t('wallet.withdraw.recipient.deleteRecipient.notification'),
		testID: 'ncw-recipientEdit-deleteSuccess-snackbar',
		variant: 'success'
	} satisfies SnackbarFixedProps;

	return {
		intlText: {
			alert: $t('wallet.withdraw.recipient.editRecipient.alert'),
			cancel: $t('wallet.withdraw.recipient.editRecipient.delete'),
			createButtonLabel: $t('wallet.withdraw.recipient.editRecipient.createButtonLabel'),
			title: $t('wallet.withdraw.recipient.editRecipient.pageTitle')
		},
		snackbarProps: {
			deleteSuccessSnackbarProp,
			editSuccessSnackbarProp
		}
	};
};
